//
// Site Header
// --------------------------------------------------
// Functionality for mobile navigation toggling

const _debounce = require('lodash.debounce');
const _throttle = require('lodash.throttle');

window.addEventListener('load', () => {
    // Dropdown Test
    const docBody = document.body;
    const siteHeader = document.getElementById('siteHeader');
    const offCanvasMenuMobile = document.getElementById('offCanvasMenuMobile');
    const menuToggleMobile = document.getElementById('menuToggleMobile');
    const navBackdropMobile = document.getElementById('navBackdropMobile');
    let scrollLimit = 500;
    let navOpenScrollPosY = window.scrollY;

    // id for below is retrieved from animated-hamburger.svg
    const hamburger = document.getElementById('ek0RzW3Va4r1');
    // https://www.svgator.com/help/getting-started/svgator-player-js-api
    // ^ related to below svgatorPlayer controls
    const player = hamburger ? hamburger.svgatorPlayer : {};

    if (offCanvasMenuMobile && menuToggleMobile) {
        menuToggleMobile.addEventListener('click', () => {
            // updates navOpenScrollPos on nav open so scroll limit can compare with the current open position
            navOpenScrollPosY = window.scrollY;

            if (siteHeader && navBackdropMobile) {
                if (siteHeader.dataset.open === 'false') {
                    siteHeader.dataset.open = 'true';
                    navBackdropMobile.dataset.open = 'true';
                }
                else {
                    siteHeader.dataset.open = 'false';
                    navBackdropMobile.dataset.open = 'false';
                }
            }

            if (hamburger) {
                if (player.play) {
                    if (player.hasEnded || player.isPlaying) {
                        player.reverse();
                    } else {
                        player.play();
                    }
                }
            }

            scrollLimit = (offCanvasMenuMobile.offsetHeight / 3) * 2;
            startListening();
        });
    }

    function closeMobileNav() {
        if (siteHeader.dataset.open === 'true') {
            siteHeader.dataset.open = 'false';
            navBackdropMobile.dataset.open = 'false';

            if (hamburger) {
                if (player.play) {
                    player.reverse();
                }
            }
        }
    }

    // closes open menus and resets nav to default state
    function closeAllNavs() {
        closeMobileNav();
    }

    function startListening() {
        window.addEventListener('click', clickListener);
        window.addEventListener('resize', resizeListener);
        window.addEventListener('scroll', scrollListener);
    }

    function stopListening() {
        window.removeEventListener('click', clickListener);
        window.removeEventListener('resize', resizeListener);
        window.removeEventListener('scroll', scrollListener);
    }

    // Throttle for resize listener to close open menus on page resize
    const closeNavResizeThrottle = _throttle(resizeCloseNav, 50, {leading: true, trailing: true});

    function resizeCloseNav() {
        let windowSize = window.innerWidth;
        setTimeout(() => {
            if (windowSize !== window.innerWidth) {
                closeAllNavs();
                stopListening();
            }
        }, 50);
    }


    // Debounce for click listener to close open menus if click is not inside menu
    const closeNavClickDebounce = _debounce(clickOutsideCloseNav, 50, {leading: true, trailing: true});

    function clickOutsideCloseNav() {
        if (!document.getElementById('siteHeader').contains(event.target)) {
            closeAllNavs();
            stopListening();
        }
    }


    // Throttle for scroll listener to close open menus if scroll exceeded scroll limit
    const closeNavScrollThrottle = _throttle(scrolledPastLimit, 50, {leading: true, trailing: true});

    function scrolledPastLimit() {
        if (window.scrollY >= (scrollLimit + navOpenScrollPosY) || window.scrollY <= (navOpenScrollPosY - scrollLimit)) {
            closeAllNavs();
            stopListening();
        }
    }

    const clickListener = () => {
        closeNavClickDebounce(event);
    };

    const resizeListener = () => {
        closeNavResizeThrottle();
    };

    const scrollListener = () => {
        closeNavScrollThrottle();
    };

    // Throttle for scroll listener to adjust nav position based on scroll
    const throttleNavScrollCheck =  _throttle(navScrollCheck, 50, {leading: true, trailing: false});
    window.addEventListener('scroll', throttleNavScrollCheck, {passive: true});

    let scrollPositive = window.scrollY + scrollLimit;
    setTimeout(() => {
        scrollPositive = window.scrollY + scrollLimit;
    }, 100);

    function navScrollCheck() {
        const scrollPos = window.scrollY;

        setTimeout(() => {
            if (scrollPos > window.scrollY) {
                setNavStyles(true);
                scrollPositive = scrollPos + scrollLimit;
            } else if (scrollPos < window.scrollY) {
                if (scrollPositive < scrollPos) {
                    scrollPositive = scrollPos + scrollLimit;
                    setNavStyles(false);
                }
            }
        }, 50);
    }

    // set nav position on load
    setNavStyles(true);

    // set nav pos / styles based on scrolling
    function setNavStyles(negScroll) {
        if (siteHeader && docBody) {
            if (window.scrollY > scrollLimit && !negScroll) {
                siteHeader.dataset.visible = 'false';
                docBody.dataset.navVisible = 'false';
            }
            else if (window.scrollY > scrollLimit && negScroll) {
                siteHeader.dataset.visible = 'true';
                docBody.dataset.navVisible = 'true';
            }
            else {
                siteHeader.dataset.visible = 'true';
                docBody.dataset.navVisible = 'true';
            }
        }
    }

    // Keeps offcanvas nav hidden for 500ms on page load to mask transitions
    setTimeout(function() {
        document.getElementById('offCanvasMenuMobile')?.removeAttribute('style');
    }, 500);
});